import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const cameraSetCredentialsAtom = createMutationAtomFactory(
  'settings.cameraSetCredentials',
  (params: { id: string; username: string; password: string }) => ({
    iotCameraSetCredentials: {
      __args: {
        id: params.id,
        username: params.username,
        password: params.password,
      },
      id: true,
      username: true,
    },
  }),
);
